import React from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useParams,
} from "react-router-dom";
import Home from "./components/Home";

import TermsAndCondition from "./components/TermsAndCondition";
import HeaderFooterWrapper from "./components/HeaderFooterWrapper";
import PrivacyPolicyDoc from "./components/PrivacyPolicyDoc";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<Home key="home-base" />} />

        <Route path="/:id" element={<HomeWithIdKey />} />

        <Route
          path="/privacy-policy"
          element={
            <HeaderFooterWrapper>
              <PrivacyPolicyDoc />
            </HeaderFooterWrapper>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <HeaderFooterWrapper>
              <TermsAndCondition />
            </HeaderFooterWrapper>
          }
        />

        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function HomeWithIdKey() {
  const { id } = useParams();
  return <Home key={id} />;
}

export default App;
